// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthProviderButton_container__RMG9J","google":"AuthProviderButton_google__1qBBt"};